import React, { useState } from 'react';
import './TextEditor.css';

interface TextEditorProps {
  fileName?: string;
  initialContent?: string;
  readOnly?: boolean;
}

const TextEditor: React.FC<TextEditorProps> = ({ 
  fileName = 'Untitled.txt', 
  initialContent = '',
  readOnly = false 
}) => {
  const [content, setContent] = useState(initialContent);

  const sampleTexts: Record<string, string> = {
    'credits.txt': `in orbit – an ep by adhiv dhar

tracklist:
- la paix
- your orbit
- things change
- everytime
- need you
- simmering

mixed and mastered by sanjeevi easwar.
thank you to my collaborators, chloe catara, emil irimpan, karthik ravikumar, and nellybombs.
thank you to kaushik ravikumar and prateek agarwal for additional support on production, michael edwards for taking my photos, and shankara for feedback.
and of course, thank you to mom, dad, anish, and preeya for unwavering support of my dreams
    
produced and recorded in brooklyn ny`,
    'abandoned.txt': `if i had all the time in the world, I might spend my time working on my art projects forever. but we don't have all the time, and i don't believe in perfect. art is never finished, only abandoned. the tracks and ideas in this folder couldn't find a home on the project, so I left them, sold them for parts, recycled bits into the other songs. 
    
normally they never have a place to live besides a remarkably large demo folder on my laptop. so instead, here I lay them to rest. perhaps for a future you or me will sample, steal, or build with one of them. who knows. cheers <3`
  };

  const displayContent = sampleTexts[fileName] || content;

  return (
    <div className="text-editor">
      <div className="text-editor-content">
        <textarea 
          value={displayContent}
          onChange={(e) => setContent(e.target.value)}
          readOnly={readOnly}
          className="text-area"
          placeholder="Start typing..."
        />
      </div>
    </div>
  );
};

export default TextEditor;